<template>
  <div class="w-100">
    <label class="small font-weight-bold mb-1">{{ $t('note') }}</label>
    <b-form-textarea v-model="text" rows="2" max-rows="6" :maxlength="maxLength" :placeholder="$t('placeholder')"></b-form-textarea>
    <div class="d-flex align-items-center mt-1" style="gap:.5rem">
      <span class="small text-gray-999" v-if="doc.noteTime">
        {{ $t('updatedBy') }} <b>{{ doc.noteBy && doc.noteBy.name ? doc.noteBy.name : '—' }}</b>
        — {{ doc.noteTime | moment('DD/MM/YYYY HH:mm') }}
      </span>
      <span class="ml-auto">
        <button class="btn btn-sm btn-outline-secondary is-border-1 mr-1" v-if="changed" @click="text = doc.note || ''" :disabled="saving">
          {{ $t('cancel') }}
        </button>
        <button class="btn btn-sm btn-primary" @click="save" :disabled="!changed || saving">
          <font-awesome-icon icon="save"/>&nbsp;{{ $t('save') }}
        </button>
      </span>
    </div>
  </div>
</template>

<script>
// Ô ghi chú cho một kỳ đối soát — dùng chung ở 3 màn Đối soát (ZBS, SMS, trạng thái gửi SMS).
export default {
  name: 'ReconcileNote',
  props: {
    // Bản ghi kỳ đối soát, cần _id, note, noteBy, noteTime.
    doc: {type: Object, required: true},
    // Gốc API của màn, ví dụ '/zns-reconcile'.
    api: {type: String, required: true},
  },
  data() {
    return {text: this.doc.note || '', saving: false, maxLength: 2000};
  },
  computed: {
    changed() {
      return this.text.trim() !== (this.doc.note || '');
    },
  },
  watch: {
    'doc._id'() {
      this.text = this.doc.note || '';
    },
  },
  methods: {
    async save() {
      this.saving = true;
      try {
        const {data} = await this.$service.patch(`${this.api}/${this.doc._id}/note`, {note: this.text});
        this.text = data.data.note || '';
        this.$emit('saved', data.data);
        this.$swal({title: this.$t('saved'), icon: 'success', toast: true, position: 'top-end', timer: 1500, showConfirmButton: false});
      } catch (e) {
        this.$swal({text: (e.response && e.response.data && e.response.data.message) || e.message || this.$t('saveFailed'), icon: 'error'});
      } finally {
        this.saving = false;
      }
    },
  },
  i18n: {
    messages: {
      en: {
        note: 'Note', placeholder: 'Note for this reconciliation period (agreements with provider, reasons for differences...)',
        updatedBy: 'Updated by', save: 'Save note', cancel: 'Cancel', saved: 'Note saved', saveFailed: 'Failed to save note',
      },
      vi: {
        note: 'Ghi chú', placeholder: 'Ghi chú cho kỳ đối soát này (thống nhất với nhà cung cấp, lý do chênh lệch...)',
        updatedBy: 'Cập nhật bởi', save: 'Lưu ghi chú', cancel: 'Huỷ', saved: 'Đã lưu ghi chú', saveFailed: 'Lưu ghi chú thất bại',
      },
    },
  },
};
</script>
